import { Route } from "wouter";
import { Project } from "../components/Project";

export const ProjectRoute = () => (
  <Route path="/project/:id">{(params) => <Project id={params.id} />}</Route>
);
